import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Switch } from '@/components/ui/switch';

export type ContributionTiming = 'monthly' | 'yearly';

type ContributionTimingControlsProps = {
  value: ContributionTiming;
  onValueChange: (value: ContributionTiming) => void;
  inflationAdjusted: boolean;
  onInflationAdjustedChange: (value: boolean) => void;
};

export function ContributionTimingControls({
  value,
  onValueChange,
  inflationAdjusted,
  onInflationAdjustedChange
}: ContributionTimingControlsProps) {
  return (
    <div className="space-y-4">
      <Tabs value={value} defaultValue={value} onValueChange={(next) => onValueChange(next as ContributionTiming)}>
        <TabsList>
          <TabsTrigger value="monthly">Monthly</TabsTrigger>
          <TabsTrigger value="yearly">Yearly</TabsTrigger>
        </TabsList>

        <TabsContent value="monthly" className="text-sm text-muted-foreground">
          Contributions are modeled as 12 compounding deposits per year.
        </TabsContent>
        <TabsContent value="yearly" className="text-sm text-muted-foreground">
          Contributions are modeled as end-of-year lump sums.
        </TabsContent>
      </Tabs>

      <div className="flex items-center justify-between rounded-md border border-border bg-secondary/40 p-3">
        <div>
          <p className="text-sm font-medium text-foreground">Inflation-adjusted contributions</p>
          <p className="text-xs text-muted-foreground">Applies annual contribution step-up in projections.</p>
        </div>
        <Switch checked={inflationAdjusted} onCheckedChange={onInflationAdjustedChange} ariaLabel="Toggle inflation adjusted contributions" />
      </div>
    </div>
  );
}
